import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/API/api.service';
import { EventService } from 'src/app/services/Events/events.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { KeyFeaturesModalComponent } from '../key-features-modal/key-features-modal.component';
import { CachingService } from './../../services/cache/caching.service';
import { GlobalService } from './../../services/global/global.service';
declare const ONE3D: any;

@Component({
  selector: 'variants',
  templateUrl: './variants.component.html',
  styleUrls: ['./variants.component.scss'],
})
export class VariantsComponent implements OnInit {
  variantsFilters: any;
  variants: any;
  selectedVariant;
  variantsForUi: any;
  driveType: any;
  transmissionType: any;
  fuelType: any;
  modalOpen = false;
  singleFuelType = false;
  filtersVisible = true;
  disableFilters = false;
  showMore = false;
  seatType: any;
  variantsDetails: any;
  showFilter: boolean = false;
  constructor(
    public globalService: GlobalService,
    private cachingService: CachingService,
    private events: EventService,
    private apiService: ApiService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    if (this.globalService.selectedVariant) {
      this.selectedVariant = this.globalService.selectedVariant;
      this.getFilters(this.selectedVariant);
    } else {
      // 'no variant in ngoninit'
    }

    this.events.subscribe('events', (data) => {
      this.subscribeToEvents(data);
    });
  }
  subscribeToEvents(data) {
    let key = Object.keys(data)[0];
    switch (key) {
      case 'defaultVariant':
        this.selectedVariant = data.defaultVariant;
        this.getFilters(this.selectedVariant);
        this.globalService.selectedVariant = this.selectedVariant;
        this.globalService.setConfigData();
        break;
      case 'newConfiguration':
        this.selectedVariant = data.newConfiguration;
        this.getFilters(this.selectedVariant);
        this.globalService.selectedVariant = this.selectedVariant;
        this.globalService.setConfigData();
        break;
      case 'loadOldConfiguration':
        this.selectedVariant = data.loadOldConfiguration;
        this.getFilters(this.selectedVariant);
        this.globalService.selectedVariant = this.selectedVariant;
        this.globalService.setConfigData();
        break;
      case 'updateUIPrices':
        this.selectedVariant = data.updateUIPrices;
        this.getFilters(this.selectedVariant);
        this.globalService.selectedVariant = this.selectedVariant;
        this.globalService.setConfigData();
        break;
      case 'selectedVariant':
        this.selectedVariant = data.selectedVariant;
        this.globalService.selectedVariant = this.selectedVariant;
        this.globalService.setConfigData();
        break;
      case 'variantLoadComplete':
        this.disableFilters = false;
        break;
      default:
        break;
    }
  }

  async getFilters(selectedVariant) {
    let variant_details = await this.cachingService.getDataFromSession(
      'variants'
    );
    this.variants = variant_details.variants;
    this.showFilters(variant_details);
    this.manageFilters(selectedVariant, variant_details.filters);
  }
  // Display filters only when there is a variation in filter options across all variants.
  async showFilters(variant_details) {
    variant_details.filters.forEach((filter) => {
      if (filter.filterValues.length > 1) {
        this.showFilter = true;
      }
    });
    return this.showFilter;
  }

  manageFilters(variant, filters) {
    for (let index = 0; index < filters.length; index++) {
      if (filters[index].filterName == 'Drive') {
        filters[index].filterValue = variant.drive;
        this.driveType = variant.drive;
      } else if (filters[index].filterName == 'Transmission') {
        filters[index].filterValue = variant.transmission_code;
        this.transmissionType = variant.transmission_code;
      } else if (filters[index].filterName == 'Fuel') {
        filters[index].filterValue = variant.fuel_type;
        if (filters[index].filterValues.length <= 1) {
          this.singleFuelType = true;
        } else {
          this.singleFuelType = false;
        }
        this.fuelType = variant.fuel_type;
      } else if (filters[index].filterName == 'Seat') {
        filters[index].filterValue = variant?.num_of_seats;
        this.seatType = variant?.num_of_seats;
      }
    }
    this.variantsFilters = filters;
    this.variantsForUi = this.variants.filter((element) => {
      return (
        element.drive == variant.drive &&
        element.transmission_code == variant.transmission_code &&
        element.fuel_type == variant.fuel_type &&
        element.num_of_seats == variant.num_of_seats
      );
    });
    this.variantsForUi.sort((a: any, b: any) =>
      a.sorting > b.sorting ? 1 : b.sorting > a.sorting ? -1 : 0
    );
  }
  filterVariants(key, event) {
    let filterValue;
    filterValue = event.target.id;
    this.disableFilters = true;

    if (key == 'Drive') {
      this.sortByDriveType(filterValue);
      this.apiService.visualizerAnalytics('drive_filter');
    } else if (key == 'Transmission') {
      this.sortByTransmissionType(filterValue);
      this.apiService.visualizerAnalytics('transmission_filter');
    } else if (key == 'Fuel') {
      this.sortByFuelType(filterValue);
      this.apiService.visualizerAnalytics('fuel_filter');
    } else if (key == 'Seat') {
      this.sortBySeatType(filterValue);
      this.apiService.visualizerAnalytics('seat_filter');
    }
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Toggle',
      filterValue
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'variants_menu',
      eAct: 'variants_menu',
      eVal: filterValue,
    });
  }

  sortBySeatType(filterValue) {
    let seatTypeState = this.seatType;
    let driveTypeState = this.driveType;
    let transmissionTypeState = this.transmissionType;
    let fuelTypeState = this.fuelType;
    this.seatType = filterValue;
    this.variantsForUi = this.variants.filter((el) => {
      return (
        el.drive == this.driveType &&
        el.transmission_code == this.transmissionType &&
        el.fuel_type == this.fuelType &&
        el.num_of_seats == filterValue
      );
    });
    this.sortOrderForVariants(
      driveTypeState,
      transmissionTypeState,
      fuelTypeState,
      seatTypeState
    );
  }

  sortByDriveType(filterValue) {
    let seatTypeState = this.seatType;
    let driveTypeState = this.driveType;
    let transmissionTypeState = this.transmissionType;
    let fuelTypeState = this.fuelType;
    this.driveType = filterValue;
    this.variantsForUi = this.variants.filter((el) => {
      return (
        el.drive == filterValue &&
        el.transmission_code == this.transmissionType &&
        el.fuel_type == this.fuelType &&
        el.num_of_seats == this.seatType
      );
    });

    this.sortOrderForVariants(
      driveTypeState,
      transmissionTypeState,
      fuelTypeState,
      seatTypeState
    );
  }
  sortByTransmissionType(filterValue) {
    let seatTypeState = this.seatType;
    let driveTypeState = this.driveType;
    let transmissionTypeState = this.transmissionType;
    let fuelTypeState = this.fuelType;
    this.transmissionType = filterValue;
    if (this.transmissionType == '6MT') {
      this.driveType = '4x2';
    }
    this.variantsForUi = this.variants.filter((el) => {
      return (
        el.transmission_code == filterValue &&
        el.drive == this.driveType &&
        el.fuel_type == this.fuelType &&
        el.num_of_seats == this.seatType
      );
    });
    this.sortOrderForVariants(
      driveTypeState,
      transmissionTypeState,
      fuelTypeState,
      seatTypeState
    );
  }
  sortByFuelType(filterValue) {
    let seatTypeState = this.seatType;
    let driveTypeState = this.driveType;
    let transmissionTypeState = this.transmissionType;
    let fuelTypeState = this.fuelType;
    this.fuelType = filterValue;
    this.variantsForUi = this.variants.filter((el) => {
      return (
        el.fuel_type == filterValue &&
        el.transmission_code == this.transmissionType &&
        el.drive == this.driveType
      );
    });
    this.sortOrderForVariants(
      driveTypeState,
      transmissionTypeState,
      fuelTypeState,
      seatTypeState
    );
  }
  sortOrderForVariants(
    driveType,
    transmissionType,
    fuelTypeState,
    seatTypeState
  ) {
    this.variantsForUi.sort((a: any, b: any) =>
      a.sorting > b.sorting ? 1 : b.sorting > a.sorting ? -1 : 0
    );
    let selectedVariant = this.variantsForUi[0];
    if (selectedVariant) {
      this.selectVariantCheck(
        selectedVariant,
        driveType,
        transmissionType,
        fuelTypeState,
        seatTypeState
      );
    } else {
      this.disableFilters = false;
    }
  }

  // to check if any finance options is added while switching variant
  async addedFinanceOptions() {
    const emi = await this.cachingService.getDataFromSession('emi_details');
    const carExchange = await this.cachingService.getDataFromSession('exchange_values');
    const extendedWarranty = await this.cachingService.getDataFromSession('extendedWarranty_details');
    const amc = await this.cachingService.getDataFromSession('amc_details');
    const insurance = await this.cachingService.getDataFromSession('insurancePlan_details');

    if (emi?.EstimatedMonthlyPayment || carExchange?.MinimumValue || extendedWarranty?.warrantyPrice || amc?.AnnualMaintenanceContractPrice || insurance?.insuranceCost)
      return true;
    return false;
  }

  /**
   * On click of accordion, log info click GA event &
   * set showMore to false so that on toggle of other accordion full content is not visible
   *
   * @param variantName name of variant
   * @param i index
   */
  toggleAccordionClick(variantName, i) {
    this.showMore = false;
    let el = document.querySelectorAll('.one3d-acc-variants');

    if (
      el[i].classList.contains('accordion-collapsed') ||
      el[i].classList.contains('accordion-collapsing')
    ) {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::Variant_Info_Open',
        variantName
      );
    } else if (
      el[i].classList.contains('accordion-expanded') ||
      el[i].classList.contains('accordion-expanding')
    ) {
      this.apiService.logGAEvent(
        'uaevent',
        'Content',
        'Click::Variant_Info_Close',
        variantName
      );
    } else {
      // 'else toggleAccordionClick'
    }
  }

  async selectVariantCheck(
    selectedVariant,
    driveType?,
    transmissionType?,
    fuelTypeState?,
    seatTypeState?
  ) {
    if (
      this.selectedVariant.variant_id == selectedVariant.variant_id ||
      this.modalOpen
    )
      return;
    if (
      this.globalService.addedAccessories.length > 0 ||
      this.globalService.addedAccessoriesPacks.length > 0 ||
      (await this.addedFinanceOptions())
    ) {
      this.modalOpen = true;
      const modal = await this.modalController.create({
        component: ConfirmationModalComponent,
        componentProps: {
          msg: {
            icon: 'assets/icons/icon-switching-variant.svg',
            header: 'SWITCH_VARIANTS.HEADER',
            content: 'SWITCH_VARIANTS.CONTENT',
            cancelText: 'SWITCH_VARIANTS.CANCEL',
            confirmText: 'SWITCH_VARIANTS.CONFIRM',
          },
        },
        backdropDismiss: false,
        cssClass: 'confirmation-modal',
      });
      await modal.present();
      const { data } = await modal.onDidDismiss();
      if (data) {
        if(ONE3D && ONE3D.removeAllAccessories && typeof ONE3D.removeAllAccessories === 'function'){
          ONE3D.removeAllAccessories()
        }
        this.globalService.addedAccessories = [];
        this.globalService.addedAccessoriesPacks = [];
        this.selectVariant(selectedVariant);
        this.cachingService.removeDataFromSession('emi_details');
        this.cachingService.removeDataFromSession('exchange_values');
        this.cachingService.removeDataFromSession('extendedWarranty_details');
        this.cachingService.removeDataFromSession('amc_details');
        this.cachingService.removeDataFromSession('insurancePlan_details');
        this.cachingService.removeDataFromSession('buildName');
      } else {
        driveType ? (this.driveType = driveType) : null;
        transmissionType ? (this.transmissionType = transmissionType) : null;
        fuelTypeState ? (this.fuelType = fuelTypeState) : null;
        seatTypeState ? (this.seatType = seatTypeState) : null;
        this.disableFilters = false;
        this.sortByDriveType(this.driveType);
        this.sortByFuelType(this.fuelType);
        this.sortByTransmissionType(this.transmissionType);
        this.sortBySeatType(this.seatType);
      }
      setTimeout(() => {
        this.modalOpen = false;
      }, 500);
    } else {
      this.selectVariant(selectedVariant);
    }
  }
  async selectVariant(selectedVariant) {
    this.events.publish('events', { selectedVariant: selectedVariant });
    await this.globalService.getVariantDetails(selectedVariant);
    this.selectedVariant = selectedVariant;
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Variant',
      selectedVariant.variant_name
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'variant_change',
      eAct: 'variant_change',
    });
    this.apiService.updateReportingData('eLa2', selectedVariant.variant_name);
    this.apiService.visualizerAnalytics(
      'variant_switch',
      String(selectedVariant.variant_id)
    );
  }

  async showKeyFeatures(variant) {
    this.apiService.visualizerAnalytics('variant_info');
    const modal = await this.modalController.create({
      component: KeyFeaturesModalComponent,
      componentProps: {
        variants: this.variantsForUi,
        infoForVariant: variant,
        selectedVariant: this.selectedVariant,
      },
      backdropDismiss: false,
      animated: false,
      cssClass: 'one3d-keyFeatures-modal',
    });

    await modal.present();
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Variant_Info_Open',
      variant.variant_name
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'variant_info',
      eAct: 'variant_info',
    });
  }
  showHideFilters() {
    this.filtersVisible = !this.filtersVisible;
  }
  /**
   * TO check if variant loaded with default pack or not
   *
   * @param variant variant data
   * @returns true/false
   */
  checkIfDefaultPackLoaded(variant) {
    let defaultPackLoaded;

    variant.packages.forEach((pack) => {
      if (pack.is_default === 'yes') {
        defaultPackLoaded = pack;
      }
    });
    return defaultPackLoaded ? true : false;
  }

  /**
   * Returns variant's default pack loaded detail
   *
   * @param variant variant data
   * @param packParams pack parameter
   * @returns value of that parameter
   */
  defaultPackLoadedDetails(variant, packParams) {
    let defaultPackLoaded;

    variant.packages.forEach((pack) => {
      if (pack.is_default === 'yes') {
        defaultPackLoaded = pack;
      }
    });

    if (packParams === 'price') {
      return defaultPackLoaded ? defaultPackLoaded.pack_price : '';
    } else if (packParams === 'name') {
      return defaultPackLoaded ? defaultPackLoaded.packageName : '';
    } else {
      return;
    }
  }
}
